import { Container } from "react-bootstrap";
import React from "react";
import { useLocation } from "react-router-dom";
import "../../Membership/Membership.scss";
import BuyEventForm from "../../../Common/StripeForms/BuyEvent";

export const PurchaseEvent = () => {
  const location: any = useLocation();

  return (
    <div className="nonMember">
      <Container fluid className="paymentUI-main">
        <div className="step-innercontent step5 payment-step5">
          <h3>Payment details</h3>
          <div className="mt-3 mb-5">
            <BuyEventForm eventData={location?.state?.obj} />
          </div>
        </div>
      </Container>
    </div>
  );
};
